import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import { isAdmin } from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { useStore } from "app/stores";

const UncompletedServiceSearch = ({ isOpenFillter,readOnly }) => {
  const isAdmins = isAdmin();

  const { handleChangeFormSearchUncompletedService } =
    useStore().patientManagementStore.uncompletedRegisterServiceStore;

  const { values } = useFormikContext();

  async function handleSearch() {
    try {
      handleChangeFormSearchUncompletedService(values);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      {!isOpenFillter && (
        <>
          <style>
            {`
                @keyframes slideDownFade {
                  0% {
                    opacity: 0;
                    transform: translateY(-10px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}
          </style>
          <div
            style={{
              animation: "slideDownFade 0.3s ease forwards",
            }}
          >
            <Grid container spacing={1} className="cards-body">
              {/* <Grid item xs={12} sm={6} md={3}>
        <GlobitsTextField
          label="Tìm kiếm"
          placeholder="Nhập Mã/Tên/SĐT"
          name="keyword"
        />
      </Grid> */}
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsDateTimePicker label="Từ ngày" name="fromDate" disabled={readOnly} />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsDateTimePicker label="Đến ngày" name="toDate" disabled={readOnly} />
              </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={"auto"}
                  className="flex flex-end gap-2"
                  >
                  {!readOnly && (
                  <Button
                    onClick={handleSearch}
                    className="btn-primary"
                    // type="submit"
                  >
                    <Search />
                    Tìm kiếm
                  </Button>
                )}
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default memo(observer(UncompletedServiceSearch));
